import { makeStyles, useMediaQuery } from '@material-ui/core'
import { authSelectors } from 'ducks/auth'
import { orderSelectors } from 'ducks/orderComponents'
import { CountryAndLocaleMenuButton } from 'expo/CountryAndLocaleMenuButton'
import { ExpoContextProvider } from 'expo/ExpoContext'
import ActivityButtonIcon from 'layout/widgets/ActivityButtonIcon'
import ChatDrawerButton from 'layout/widgets/adaChat/ChatDrawerButton'
import { useAdaActive } from 'layout/widgets/adaChat/useAdaActive'
import CreateProjectButton from 'layout/widgets/CreateProjectButton'
import SupportButton from 'layout/widgets/SupportButton'
import UserSettingsDropdown from 'layout/widgets/UserSettingsDropdown'
import LogoOrTitle from 'myenergy/mainContent/components/LogoOrTitle'
import { ComponentVersions_2_0, ComponentVersionsInherit } from 'opensolar-ui'
import ShopCartButton from 'pages/ordering/subheader/ShopCartButton'
import SearchBar from 'persistentContent/elements/SearchBar'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { OpenSolarThemeType } from 'Themes'
import { OrgType } from 'types/orgs'
import { useFeatureFlag } from 'util/featureFlags'
import { DialogHelper } from 'util/misc'
import Navigation from './elements/Navigation'

const useStyles = makeStyles((theme: OpenSolarThemeType) => ({
  logo: {
    display: 'flex',
    paddingLeft: theme.name === 'nearmap' ? 10 : 20,
    color: theme.headerFontColor,

    '& img': {
      padding: theme.name === 'nearmap' ? '3px 4px !important' : 'unset',
      backgroundColor: theme.name === 'nearmap' ? 'white' : 'unset',
      borderRadius: theme.name === 'nearmap' ? 2 : 'unset',
    },
  },
  end: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexGrow: 1,
    gap: 5,
    height: 50,
    paddingRight: 10,
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
  },
}))

export interface NavProps {
  isUserLite: boolean
  isNearmapSkin: boolean
  layout: number
  org: OrgType
  zone: string
  projectId: number
  setSelectOrgVisible: (value) => void
  setAvailableOrgs: (value) => void
}

const OSHeader: React.FC<NavProps> = (props) => {
  const {
    isUserLite,
    isNearmapSkin,
    layout,
    org,
    zone,
    projectId,
    setSelectOrgVisible,
    setAvailableOrgs,
    ...otherProps
  } = props
  const classes = useStyles()
  const location = useLocation()
  const history = useHistory()
  const briefOrgs = useSelector(authSelectors.getBriefOrgs)
  const cartItems = useSelector(orderSelectors.getConfirmedLineItems)
  const cobrandingOrg = isUserLite ? undefined : org?.cobranding_org
  const isMobile = useMediaQuery((theme: OpenSolarThemeType) => theme.breakpoints.down('sm'))
  const isHomePage = location.pathname === '/' || location.pathname === '/home'
  const isExplorePage = location.pathname === '/projects/new/explore'
  const isInExpoRoute = useMemo(() => {
    const path = history.location.pathname
    return path.includes('/expo') && !path.startsWith('/expo_')
  }, [history.location.pathname])
  const { active: showChatDrawerButton } = useAdaActive()
  const isActivityCenterOn = useFeatureFlag('actions_activity_centre', 'on')

  return (
    <ComponentVersionsInherit versions={ComponentVersions_2_0}>
      <div className={classes.wrapper}>
        <div className={classes.logo}>
          <LogoOrTitle
            size={layout > 2 ? 'small' : 'cobrandingsmall'}
            org={org}
            allowUploadButton={false}
            style={undefined}
            skipTitle={undefined}
            skipTitleStyle={undefined}
            containerStyle={undefined}
            textStyle={undefined}
          />
        </div>

        {!isMobile && <Navigation {...props} />}
        <div id="header-profile-area" className={classes.end}>
          {cartItems.length > 0 &&
            !isHomePage &&
            !isExplorePage &&
            zone !== 'shop' &&
            (layout > 2 || !isNearmapSkin) && <ShopCartButton isInventory={true} />}

          {isInExpoRoute && (
            <ExpoContextProvider>
              <CountryAndLocaleMenuButton />
            </ExpoContextProvider>
          )}

          {!isHomePage && !isExplorePage && (layout > 2 || !isNearmapSkin) && <CreateProjectButton layout={layout} />}
          {isActivityCenterOn && <ActivityButtonIcon />}
          {showChatDrawerButton && <ChatDrawerButton iconColor="primary" />}
          <SearchBar />
          <SupportButton iconColor="primary" />
          <UserSettingsDropdown
            showOrgSelector={() => {
              DialogHelper.afterOpen()
              setSelectOrgVisible(true)
              setAvailableOrgs(briefOrgs)
            }}
            layout={layout}
          />
          {isNearmapSkin && (
            <img
              alt="co-branding"
              src={window.PUBLIC_URL + '/images/co-branding-logo.png'}
              style={{ width: layout > 1 ? 80 : 55 }}
            />
          )}
          {cobrandingOrg && layout > 1 && (
            <div style={{ display: 'flex', paddingRight: 20 }}>
              <LogoOrTitle
                size={layout > 2 ? 'small' : 'cobrandingsmall'}
                org={cobrandingOrg}
                allowUploadButton={false}
                style={undefined}
                skipTitle={undefined}
                skipTitleStyle={undefined}
                containerStyle={undefined}
                textStyle={undefined}
              />
            </div>
          )}
        </div>
      </div>
    </ComponentVersionsInherit>
  )
}
export default OSHeader
